import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { CourseRegistrationSetupTypes } from "./types";
import {
	createCourseRegistrationSetupSuccess,
	createCourseRegistrationSetupFailure,
	getAllCourseRegistrationSetupsSuccess,
	getAllCourseRegistrationSetupsFailure,
	notifyStudentsSuccess,
	notifyStudentsFailure,
} from "./actions";
import { callApiPost, callApiGet, callApiDelete } from "../../utils/api";

function* createCourseRegistrationSetupCall({ payload }: { type: string; payload: any }) {
	try {
		const res = yield call(callApiPost, "course-registration/setup", payload);
		yield put(createCourseRegistrationSetupSuccess(res.data));
	} catch (err: any) {
		yield put(createCourseRegistrationSetupFailure(err.response.data));
	}
}

function* getAllCourseRegistrationSetups({ payload }: { type: string; payload: any }) {
	try {
		const res = yield call(callApiGet, `course-registration/setups/school/${payload.school_id}`);
		yield put(getAllCourseRegistrationSetupsSuccess(res.data));
	} catch (err: any) {
		yield put(getAllCourseRegistrationSetupsFailure(err.response.data));
	}
}

function* notifyStudents({ payload }: { type: string; payload: any }) {
	let url = "";

	if (payload.id != "") {
		url = `course-registration/notify?school_id=${payload.school_id}&academic_year=${payload.academic_year}&semester_id=${payload.semester}&id=${payload.id}`;
	} else {
		url = `course-registration/notify?school_id=${payload.school_id}&academic_year=${payload.academic_year}&semester_id=${payload.semester}`;
	}

	try {
		const res = yield call(callApiGet, url);
		yield put(notifyStudentsSuccess(res.data));
	} catch (err: any) {
		yield put(notifyStudentsFailure(err.response.data));
	}
}

function* watchCreateCourseRegistrationSetup() {
	yield takeEvery(CourseRegistrationSetupTypes.CREATE_COURSE_REGISTRATION_SETUP, createCourseRegistrationSetupCall);
}

function* watchGetAllCourseRegistrationSetups() {
	yield takeEvery(CourseRegistrationSetupTypes.GET_ALL_COURSE_REGISTRATION_SETUPS, getAllCourseRegistrationSetups);
}

function* watchNotifyStudents() {
	yield takeEvery(CourseRegistrationSetupTypes.NOTIFY_STUDENTS, notifyStudents);
}

function* watchNotifyStudentsSuccess() {
	yield takeEvery(CourseRegistrationSetupTypes.NOTIFY_STUDENTS_SUCCESS, notifyStudentsSuccess);
}

function* watchNotifyStudentsFailure() {
	yield takeEvery(CourseRegistrationSetupTypes.NOTIFY_STUDENTS_FAILURE, notifyStudentsFailure);
}

function* CourseRegistrationSetupsSaga() {
	yield all([
		fork(watchCreateCourseRegistrationSetup),
		fork(watchGetAllCourseRegistrationSetups),
		fork(watchNotifyStudents),
		fork(watchNotifyStudentsSuccess),
		fork(watchNotifyStudentsFailure),
	]);
}

export { CourseRegistrationSetupsSaga };
